// Plugin Vue 2 para cargar el pixel de BrainAgency 360 (Redpiso) y disparar conversiones

function loadScriptOnce(src, attrs = {}) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve()
        const s = document.createElement('script')
        s.async = true
        s.src = src
        Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v))
        s.onload = resolve
        s.onerror = reject
        document.head.appendChild(s)
    })
}

const BrainAgencyPixel = {
    install(Vue) {
        let _initialized = false
        let _lastSaleKey = null

        async function init() {
            if (_initialized) return
            const containerSrc = 'https://track.tagmanager.brainagency360.com/track/container/16'
            await loadScriptOnce(containerSrc, { type: 'module' })
            _initialized = true
            if (process.env.NODE_ENV !== 'production') console.info('[BrainPixel] container cargado')
        }

        function normalize(order) {
            const o = order || {}
            return {
                id: String(o.id || Date.now()),
                amount: Number.isFinite(Number(o.amount)) ? Number(o.amount) : 0,
                currency: String(o.currency || 'EUR').toUpperCase(),
                items: Array.isArray(o.items) ? o.items : []
            }
        }

        function trackSale(order) {
            const payload = normalize(order)
            const saleKey = `${payload.id}|${payload.amount}|${payload.currency}`
            if (saleKey === _lastSaleKey) return
            _lastSaleKey = saleKey

            const saleSrc = 'https://track.tagmanager.brainagency360.com/track/sale-tag/16'
            const s = document.createElement('script')
            s.async = true
            s.src = saleSrc
            s.setAttribute('data-order', JSON.stringify(payload))
            document.head.appendChild(s)
            if (process.env.NODE_ENV !== 'production') console.info('[BrainPixel] sale disparado', payload)
        }

        Vue.prototype.$brainPixel = {
            init,
            trackSale,
            get initialized() { return _initialized }
        }
    }
}

export default BrainAgencyPixel